// Q-DASH (1), HER ORDER: "a 'Dashboard' button next to her member button on 12th House, owners only".
//
// Its own file for NavUpgrade's reason: the whole of it is a CONDITION (who sees it), and a component a gate can CALL
// answers that where a regex over App.tsx cannot. Owners only, and an owner flag that has not arrived yet draws nothing.
// This is convenience, not security: every dashboard endpoint checks the role on the server regardless.
import { LayoutDashboard } from "lucide-react";

export function NavDashboard({ isOwner, onOpen }: {
  /** The server's word that this seat is an owner. Anything but `true` draws nothing. */
  isOwner: boolean;
  onOpen: () => void;
}) {
  if (isOwner !== true) return null;
  return (
    <button type="button" className="login-pill nav-dashboard" onClick={onOpen} aria-label="Open your dashboard">
      <LayoutDashboard size={16} />
      <span className="nav-dashboard__label">Dashboard</span>
    </button>
  );
}
